exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-price[data-v-99ab1b8c]{font-size:24px;font-weight:700;line-height:32px}.transition-errors-enter[data-v-99ab1b8c],.transition-errors-leave-to[data-v-99ab1b8c]{height:0;margin:0;padding:0;opacity:0}.transition-errors-enter-active[data-v-99ab1b8c],.transition-errors-leave-active[data-v-99ab1b8c]{transition:all .3s}", ""]);

// exports
